export const transformCategoriesData = (data) => {
    const newArray = [];
    data.forEach(item => {
        newArray.push({ value: item.name, label: item.name, ...item, name: 'categories' });
    })
    return newArray;
}